var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSketchLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 85,
    r: 81,
    fill: "white",
    stroke: "#233C85",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.3409 49.9693L85 47.5L109.659 49.9693L128.75 74.2437L85 122.5L41.25 74.2437L60.3409 49.9693Z",
    fill: "#FDB300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9707 74.2422L84.9997 122.498L41.25 74.2422H58.9707ZM111.029 74.2422L84.9997 122.498L128.75 74.2422",
    fill: "#EA6C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.9717 74.2422H111.029L85.0007 122.498",
    fill: "#FDAD00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0007 47.5L60.3416 49.9689L58.9717 74.2434L85.0007 47.5ZM85.0007 47.5L109.66 49.9689L111.03 74.2434",
    fill: "#FDD231"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128.75 74.2433L109.659 49.9688L111.029 74.2433H128.75ZM41.25 74.2433L60.3407 49.9688L58.9707 74.2433",
    fill: "#FDAD00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.0007 47.5L58.9717 74.2434H111.029",
    fill: "#FEEEB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSketchLogo);
export default __webpack_public_path__ + "static/media/sketchLogo.b172322fa3e7e120866d8c1fa3e9003f.svg";
export { ForwardRef as ReactComponent };